import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import ptBr from 'element-plus/es/locale/lang/pt-br'

const LOCALE_KEY = 'app-locale'

const elmLocaleMap: Record<string, any> = {
  'zh-CN': zhCn,
  'en-US': en,
  'pt-BR': ptBr,
}

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<string>(localStorage.getItem(LOCALE_KEY) || 'zh-CN')

  const elmLocale = computed(() => elmLocaleMap[locale.value] || zhCn)

  function setLocale(lang: string) {
    locale.value = lang
    localStorage.setItem(LOCALE_KEY, lang)

    // 同步更新 vue-i18n 全局 locale
    try {
      const { locale: i18nLocale } = (window as any).__i18n__ || {}
      if (i18nLocale) {
        i18nLocale.value = lang
      }
    } catch {
      /* 忽略：i18n 可能还未初始化 */
    }

    // 同步更新 html lang 属性
    document.documentElement.lang = lang
  }

  return {
    locale,
    elmLocale,
    setLocale,
  }
})
